import ChatService from "../../../front-services/ChatService";

const Utility = {
  getTime: () => {
    const date = new Date();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  },
  generateUniqueId: () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  },
  getWithParams: (
    href: any,
    assistantId: any,
    threadId: any,
    isQuote: boolean
  ) => {
    if (ChatService.isHM(assistantId) && threadId) {
      href += href.includes("?") ? `&d_id=${threadId}` : `?d_id=${threadId}`;
      if (isQuote) href += "#preventivo";
    }

    return href;
  },
};

export default Utility;
